module.exports = __webpack_public_path__ + "static/statistics_img.6afc4a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/statistics_img.png
// module id = 227
// module chunks = 193162123475590 216210090109534